import { render, staticRenderFns } from "./GroupServiceList.vue?vue&type=template&id=4b4d27ae&scoped=true&"
import script from "./GroupServiceList.vue?vue&type=script&lang=js&"
export * from "./GroupServiceList.vue?vue&type=script&lang=js&"
import style0 from "./GroupServiceList.vue?vue&type=style&index=0&id=4b4d27ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d27ae",
  null
  
)

export default component.exports